import styles from './Button.module.css'

export type ButtonVariant = 'default' | 'primary' | 'secondary' | 'ghost' | 'icon'
export type ButtonSize = 'default' | 'sm'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  href?: string
  as?: 'button' | 'a'
}

export function Button({
  variant = 'default',
  size = 'default',
  href,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const cls = [
    styles.btn,
    variant !== 'default' && styles[`btn-${variant}`],
    size === 'sm' && styles['btn-sm'],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  if (href) {
    return (
      <a href={href} className={cls} {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}>
        {children}
      </a>
    )
  }

  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  )
}
